import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, ArrowRight, ArrowLeft, CheckCircle } from 'lucide-react';
import { API } from '../utils/apiBase';


const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 pt-20" data-testid="forgot-password-success">
        <div className="w-full max-w-md text-center">
          <div className="w-16 h-16 bg-[#10b981] flex items-center justify-center mx-auto mb-6">
            <CheckCircle size={32} className="text-white" />
          </div>
          <h1 className="font-satoshi text-3xl font-black tracking-tight text-[#0f1115] mb-4">
            Check your email
          </h1>
          <p className="text-[#4b5563] mb-8">
            We've sent a password reset link to <strong>{email}</strong>. The link will expire in 1 hour.
          </p>
          <Link
            to="/login"
            className="inline-flex items-center space-x-2 text-[#002fa7] font-medium hover:underline"
          >
            <ArrowLeft size={20} />
            <span>Back to login</span>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-20" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <h1 className="font-satoshi text-3xl font-black tracking-tight text-[#0f1115]">
            Reset your password
          </h1>
          <p className="mt-2 text-[#4b5563]">
            Enter your email and we'll send you a reset link
          </p>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-[#fef2f2] border border-[#e11d48] text-[#e11d48] text-sm" data-testid="forgot-password-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-[#0f1115] mb-2">
              Email
            </label>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6b7280]" size={20} />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-12 pr-4 py-3 border border-[#e5e7eb] bg-white text-[#0f1115] focus:border-[#002fa7] transition-colors"
                placeholder="you@example.com"
                required
                data-testid="forgot-password-email"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full btn-primary flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="forgot-password-submit"
          >
            <span>{loading ? 'Sending...' : 'Send Reset Link'}</span>
            {!loading && <ArrowRight size={20} />}
          </button>
        </form>

        <p className="mt-8 text-center">
          <Link
            to="/login"
            className="inline-flex items-center space-x-2 text-[#002fa7] font-medium hover:underline"
          >
            <ArrowLeft size={20} />
            <span>Back to login</span>
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
